<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      center
      :before-close="handleClose"
    >
      <!-- 实物商品表单 -->
      <el-form :model="form" ref="exchangeForm" v-if="goodsData.type === '1'">
        <el-form-item :label="$t('exchangeDialog.exchange1')">
          <el-input
            v-model="form.receive_name"
            :placeholder="$t('exchangeDialog.exchange2')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('exchangeDialog.exchange3')">
          <el-input
            v-model="form.mobile"
            :placeholder="$t('exchangeDialog.exchange4')"
          >
            <template slot="prepend">84-</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('exchangeDialog.exchange5')">
          <el-input
            v-model="form.address"
            :placeholder="$t('exchangeDialog.exchange6')"
            type="textarea"
            rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('exchangeDialog.exchange7')"
          v-if="goodsData.pay_type === '2'"
        >
          <el-radio-group v-model="form.pay_type">
            <el-radio
              :label="item.pay_type"
              border
              v-for="item in payMethodList"
              :key="item.pay_type"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <!-- 虚拟商品表单 -->
      <div v-else>
        <div class="exchaneText">{{ $t("exchangeDialog.exchange8") }}</div>
        <div v-if="goodsData.pay_type === '2'">
          <el-form :model="form" ref="exchangeForm">
            <el-form-item :label="$t('exchangeDialog.exchange7')">
              <el-radio-group v-model="form.pay_type">
                <el-radio
                  :label="item.pay_type"
                  border
                  v-for="item in payMethodList"
                  :key="item.pay_type"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{
          $t("exchangeDialog.exchange9")
        }}</el-button>
        <el-button type="primary" @click="handleExchange">{{
          $t("exchangeDialog.exchange10")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";

export default {
  name: "ExchangeDialog",
  data() {
    return {
      goodsData: {},
      dialogFormVisible: false,
      form: {
        receive_name: "",
        mobile: "",
        address: "",
        pay_type: "",
      },
      payMethodList: [],
    };
  },
  computed: {
    dialogTitle() {
      return this.goodsData.name || this.$t("exchangeDialog.exchange11");
    },
  },
  methods: {
    /**
     * 打开对话框
     */
    open(goods) {
      if (goods) {
        this.goodsData = { ...goods };
        // 如果有支付方式列表，则赋值
        if (goods.atmList && goods.atmList.length > 0) {
          this.payMethodList = goods.atmList;
          this.form.pay_type = goods.atmList[0].pay_type;
        }
      }
      this.dialogFormVisible = true;
      this.$handlePadding();
    },

    /**
     * 处理兑换
     */
    handleExchange: debounce(function () {
      this.performExchange();
    }, 300),

    /**
     * 执行兑换逻辑
     */
    performExchange() {
      // 实物商品验证
      if (this.goodsData.type === "1") {
        const { receive_name, mobile, address } = this.form;
        if (!receive_name || !mobile || !address) {
          this.$message.warning(this.$t("exchangeDialog.exchange12"));
          return;
        }
      }

      // 支付方式验证
      if (this.goodsData.pay_type === "2" && !this.form.pay_type) {
        this.$message.warning(this.$t("exchangeDialog.exchange13"));
        return;
      }

      // 构建请求参数
      let params = {
        goods_id: this.goodsData.id,
        ...this.form,
      };

      // 实物商品需要添加收货信息
      if (this.goodsData.is_virtual === "0") {
        params.receive_name = this.form.receive_name;
        params.mobile = "84-" + this.form.mobile;
        params.address = this.form.address;
      }

      console.log("兑换参数:", params);

      // 调用API进行兑换
      this.$http
        .post("/point/exchange", params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(
              res.data.msg || this.$t("exchangeDialog.exchange14")
            );

            // 处理返回结果
            if (res.data.data.gift_code) {
              this.$message.success(`code: ${res.data.data.gift_code}`);
            } else if (res.data.data.redirect_url) {
              window.location.href = res.data.data.redirect_url;
            }

            // 清空表单
            this.resetForm();
            this.dialogFormVisible = false;

            // 触发刷新事件，通知父组件更新列表数据
            this.$emit("exchange-success");
          } else {
            this.$message.error(
              res.data.msg || this.$t("exchangeDialog.exchange15")
            );
          }
        })
        .catch((err) => {
          console.error("error:", err);
          this.$message.error(err);
        });
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        receive_name: "",
        mobile: "",
        address: "",
        pay_type: "",
      };
      if (this.$refs.exchangeForm) {
        this.$refs.exchangeForm.clearValidate();
      }
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.resetForm();
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  width: 400px;
  border-radius: 16px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__title {
    font-size: 18px;
    font-weight: 600;
  }

  .el-dialog__close {
    top: 18px;
    right: 18px;
    font-size: 24px;
  }

  .el-dialog__body {
    padding: 32px 28px;
    background: #fff;
  }
}

.el-form {
  /deep/.el-form-item {
    margin-bottom: 22px;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;

    .el-form-item__label {
      color: #333;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 8px;
      line-height: 1;
      text-align: left;
      width: 100%;
    }

    .el-input__inner {
      border-radius: 6px;
      border: 1px solid #dcdfe6 !important;
      font-size: 14px;
      transition: border-color 0.3s ease;
      width: 100%;
      box-sizing: border-box;
      color: black;

      &:focus,
      &:hover {
        border-color: #409eff !important;
      }
    }

    textarea.el-input__inner {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, sans-serif;
      resize: none;
      padding: 10px 12px;
      min-height: 80px;
    }
  }
}

// 支付方式单选框
.el-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.el-radio {
  /deep/.el-radio__inner {
    border: 1px solid #dcdfe6;
  }

  /deep/.el-radio__input {
    margin-right: 8px;
  }

  /deep/.el-radio__label {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  &.is-bordered {
    padding: 10px 14px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    margin: 0 !important;
    width: 100%;
    transition: all 0.3s ease;
    background: #fff;

    &:hover {
      border-color: #409eff;
      background: #f5f7fa;
    }
  }

  &.is-checked {
    &.is-bordered {
      border-color: #409eff;
      background: #f0f9ff;
    }
  }
}

.exchaneText {
  text-align: center;
}

// 对话框底部
.dialog-footer {
  padding: 20px 0 0 0;
  border-top: 1px solid #e4e7eb;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  /deep/.el-button {
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    padding: 10px 24px;
    transition: all 0.3s ease;
    border: none;

    &.el-button--default {
      color: #666;
      background: #f5f7fa;

      &:hover {
        background: #e8eaed;
        color: #333;
      }
    }

    &.el-button--primary {
      border: none;

      &:active {
        transform: scale(0.98);
      }
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

// 平板设备适配
@media screen and (max-width: 1024px) {
  /deep/.el-dialog {
    width: 85% !important;

    .el-dialog__body {
      padding: 24px 20px;
    }
  }

  .el-form {
    /deep/.el-form-item {
      margin-bottom: 18px;
    }
  }

  .el-radio {
    &.is-bordered {
      padding: 10px 12px;
    }
  }
}

// 手机设备适配
@media screen and (max-width: 768px) {
  /deep/.el-dialog {
    width: 95% !important;
    max-width: 100%;

    .el-dialog__header {
      padding: 18px;
    }

    .el-dialog__title {
      font-size: 15px;
    }

    .el-dialog__body {
      padding: 24px 20px;
    }
  }

  .el-form {
    /deep/.el-form-item {
      margin-bottom: 18px;

      .el-form-item__label {
        font-size: 13px;
      }

      .el-input__inner {
        font-size: 14px;
      }

      textarea.el-input__inner {
        min-height: 70px;
      }
    }
  }

  .el-radio-group {
    gap: 8px;
  }

  .dialog-footer {
    flex-direction: row;
    gap: 10px;

    /deep/.el-button {
      flex: 1;
      width: auto;
    }
  }
}

// 小手机设备适配
@media screen and (max-width: 480px) {
  /deep/.el-dialog {
    width: 98% !important;

    .el-dialog__header {
      padding: 14px;
    }

    .el-dialog__title {
      font-size: 13px;
    }

    .el-dialog__body {
      padding: 18px 14px;
    }
  }

  .el-form {
    /deep/.el-form-item {
      margin-bottom: 14px;

      .el-form-item__label {
        font-size: 12px;
        margin-bottom: 6px;
      }

      .el-input__inner {
        font-size: 13px;
        height: 36px;
      }

      textarea.el-input__inner {
        padding: 8px 10px;
        min-height: 60px;
      }
    }
  }

  .el-radio-group {
    gap: 8px;
  }

  .el-radio {
    &.is-bordered {
      padding: 8px 10px;
      font-size: 13px;
    }
  }

  .dialog-footer {
    padding-top: 12px;

    /deep/.el-button {
      padding: 8px 16px;
      font-size: 12px;
      height: 32px;
    }
  }
}
</style>
